import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

const getAuthHeader = () => ({
  Authorization: `Bearer ${JSON.parse(authenticationStore.appToken).access_token}`,
  'Content-Type': 'application/json',
})

export const KpiV2Request = {
  // ─── KPI ───────────────────────────────────────────────────────────────────

  /** GET /api/v1/kpi-v2 */
  getAll: ({ page = 0, size = 20, type, aspect_id, start_date, end_date } = {}) =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/kpi-v2`,
      headers: getAuthHeader(),
      params: { page, size, type, aspect_id, start_date, end_date },
    }),

  /** GET /api/v1/kpi-v2/:id */
  getById: id =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/kpi-v2/${id}`,
      headers: getAuthHeader(),
    }),

  /**
   * POST /api/v1/kpi-v2
   * @param {Object} data - { purpose, aspect_id, kgi, csf, kpi, measurement,
   *   indicator_weight, overall_weight, evaluation_rule,
   *   start_date, end_date, type, result, result_description, score,
   *   attachment, assignees }
   */
  create: data =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/kpi-v2`,
      headers: getAuthHeader(),
      data,
    }),

  /**
   * PUT /api/v1/kpi-v2/:id
   */
  update: (id, data) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/kpi-v2/${id}`,
      headers: getAuthHeader(),
      data,
    }),

  /** DELETE /api/v1/kpi-v2/:id */
  delete: id =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/kpi-v2/${id}`,
      headers: getAuthHeader(),
    }),

  // ─── ASPECT ────────────────────────────────────────────────────────────────

  /** GET /api/v1/kpi-v2/aspects */
  getAllAspects: () =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/kpi-v2/aspects`,
      headers: getAuthHeader(),
    }),

  /** GET /api/v1/kpi-v2/aspects/:id */
  getAspectById: id =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/kpi-v2/aspects/${id}`,
      headers: getAuthHeader(),
    }),

  /**
   * POST /api/v1/kpi-v2/aspects
   * @param {Object} data - { context, weight }
   */
  createAspect: data =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/kpi-v2/aspects`,
      headers: getAuthHeader(),
      data,
    }),

  /**
   * PUT /api/v1/kpi-v2/aspects/:id
   */
  updateAspect: (id, data) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/kpi-v2/aspects/${id}`,
      headers: getAuthHeader(),
      data,
    }),

  /** DELETE /api/v1/kpi-v2/aspects/:id */
  deleteAspect: id =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/kpi-v2/aspects/${id}`,
      headers: getAuthHeader(),
    }),

  // ─── SUB KPI ───────────────────────────────────────────────────────────────

  /** GET /api/v1/kpi-v2/sub */
  getAllSubKpi: (params = {}) =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/kpi-v2/sub`,
      headers: getAuthHeader(),
      params,
    }),

  /** GET /api/v1/kpi-v2/sub/:id */
  getSubKpiById: id =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/kpi-v2/sub/${id}`,
      headers: getAuthHeader(),
    }),

  /** POST /api/v1/kpi-v2/sub */
  createSubKpi: data =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/kpi-v2/sub`,
      headers: getAuthHeader(),
      data,
    }),

  /** PUT /api/v1/kpi-v2/sub/:id */
  updateSubKpi: (id, data) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/kpi-v2/sub/${id}`,
      headers: getAuthHeader(),
      data,
    }),

  /** DELETE /api/v1/kpi-v2/sub/:id */
  deleteSubKpi: id =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/kpi-v2/sub/${id}`,
      headers: getAuthHeader(),
    }),
}
